module.exports = __webpack_public_path__ + "static/img/logo-railpredict2.44e28bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-railpredict2.png
// module id = dCF+
// module chunks = 1